/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SummaryImport } from './routes/summary'
import { Route as SignupImport } from './routes/signup'
import { Route as SignatureImport } from './routes/signature'
import { Route as PaymentSuccessImport } from './routes/payment-success'
import { Route as PaymentCancelImport } from './routes/payment-cancel'
import { Route as OrderinfoImport } from './routes/orderinfo'
import { Route as MinicartImport } from './routes/minicart'
import { Route as LoginImport } from './routes/login'
import { Route as CustomizeImport } from './routes/customize'
import { Route as CheckoutImport } from './routes/checkout'
import { Route as CatalogImport } from './routes/catalog'
import { Route as CartImport } from './routes/cart'
import { Route as LayoutImport } from './routes/_layout'
import { Route as LayoutIndexImport } from './routes/_layout/index'
import { Route as LayoutShopImport } from './routes/_layout/shop'
import { Route as LayoutSettingsImport } from './routes/_layout/settings'
import { Route as LayoutOrdersImport } from './routes/_layout/orders'
import { Route as LayoutItemsImport } from './routes/_layout/items'
import { Route as LayoutAdminImport } from './routes/_layout/admin'

// Create/Update Routes

const SummaryRoute = SummaryImport.update({
  path: '/summary',
  getParentRoute: () => rootRoute,
} as any)

const SignupRoute = SignupImport.update({
  path: '/signup',
  getParentRoute: () => rootRoute,
} as any)

const SignatureRoute = SignatureImport.update({
  path: '/signature',
  getParentRoute: () => rootRoute,
} as any)

const PaymentSuccessRoute = PaymentSuccessImport.update({
  path: '/payment-success',
  getParentRoute: () => rootRoute,
} as any)

const PaymentCancelRoute = PaymentCancelImport.update({
  path: '/payment-cancel',
  getParentRoute: () => rootRoute,
} as any)

const OrderinfoRoute = OrderinfoImport.update({
  path: '/orderinfo',
  getParentRoute: () => rootRoute,
} as any)

const MinicartRoute = MinicartImport.update({
  path: '/minicart',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const CustomizeRoute = CustomizeImport.update({
  path: '/customize',
  getParentRoute: () => rootRoute,
} as any)

const CheckoutRoute = CheckoutImport.update({
  path: '/checkout',
  getParentRoute: () => rootRoute,
} as any)

const CatalogRoute = CatalogImport.update({
  path: '/catalog',
  getParentRoute: () => rootRoute,
} as any)

const CartRoute = CartImport.update({
  path: '/cart',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutShopRoute = LayoutShopImport.update({
  path: '/shop',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsRoute = LayoutSettingsImport.update({
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutOrdersRoute = LayoutOrdersImport.update({
  path: '/orders',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutItemsRoute = LayoutItemsImport.update({
  path: '/items',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminRoute = LayoutAdminImport.update({
  path: '/admin',
  getParentRoute: () => LayoutRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/cart': {
      preLoaderRoute: typeof CartImport
      parentRoute: typeof rootRoute
    }
    '/catalog': {
      preLoaderRoute: typeof CatalogImport
      parentRoute: typeof rootRoute
    }
    '/checkout': {
      preLoaderRoute: typeof CheckoutImport
      parentRoute: typeof rootRoute
    }
    '/customize': {
      preLoaderRoute: typeof CustomizeImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/minicart': {
      preLoaderRoute: typeof MinicartImport
      parentRoute: typeof rootRoute
    }
    '/orderinfo': {
      preLoaderRoute: typeof OrderinfoImport
      parentRoute: typeof rootRoute
    }
    '/payment-cancel': {
      preLoaderRoute: typeof PaymentCancelImport
      parentRoute: typeof rootRoute
    }
    '/payment-success': {
      preLoaderRoute: typeof PaymentSuccessImport
      parentRoute: typeof rootRoute
    }
    '/signature': {
      preLoaderRoute: typeof SignatureImport
      parentRoute: typeof rootRoute
    }
    '/signup': {
      preLoaderRoute: typeof SignupImport
      parentRoute: typeof rootRoute
    }
    '/summary': {
      preLoaderRoute: typeof SummaryImport
      parentRoute: typeof rootRoute
    }
    '/_layout/admin': {
      preLoaderRoute: typeof LayoutAdminImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/items': {
      preLoaderRoute: typeof LayoutItemsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orders': {
      preLoaderRoute: typeof LayoutOrdersImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings': {
      preLoaderRoute: typeof LayoutSettingsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/shop': {
      preLoaderRoute: typeof LayoutShopImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/': {
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  LayoutRoute.addChildren([
    LayoutAdminRoute,
    LayoutItemsRoute,
    LayoutOrdersRoute,
    LayoutSettingsRoute,
    LayoutShopRoute,
    LayoutIndexRoute,
  ]),
  CartRoute,
  CatalogRoute,
  CheckoutRoute,
  CustomizeRoute,
  LoginRoute,
  MinicartRoute,
  OrderinfoRoute,
  PaymentCancelRoute,
  PaymentSuccessRoute,
  SignatureRoute,
  SignupRoute,
  SummaryRoute,
])

/* prettier-ignore-end */
